import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'officeCalendarState';

export const getAllOfficeCalendarToday = createAsyncThunk(
    'officeCalendarStore/getAllOfficeCalendarToday',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/Office365/getPeopleWithAppointmentsNow`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    officeCalendars: [],
    status: 'idle',
    error: null,
};

const officeCalendarSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllOfficeCalendarToday.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getAllOfficeCalendarToday.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.officeCalendars = action.payload;
            })
            .addCase(getAllOfficeCalendarToday.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });
    },
});

export default officeCalendarSlice.reducer;